import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from '../../config/axiosInstance'

// --------------------- User Insights API --------------------------
export const fetchUserInsightsApi = async (data) => {
  const endPoint = `/admin/user-insights/insights` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// --------------------- User Insights Summary API --------------------------
export const fetchUserInsightsSummaryApi = async (data) => {
  const endPoint = `/admin/user-insights/insights/summary` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// --------------------- Consultant Insights API --------------------------
export const fetchConsultantInsightsApi = async (data) => {
  const endPoint = `/admin/consultant-insights/insights` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// --------------------- Consultant Insights Summary API --------------------------
export const fetchConsultantInsightsSummaryApi = async (data) => {
  const endPoint = `/admin/consultant-insights/insights/summary` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}
